import { request } from "graphql-request";
import { graphql } from "gql/gql";

import { BACKEND_DOMAIN } from "utils/constants";
import {
    buildRequestHeaders,
    buildBuildingModelRequestVariables,
} from "utils/helpers";
import { EquipmentSurveyInput } from "gql/graphql";

const queryFn = (
    accessToken: string,
    buildingModelUid: string,
    equipmentData: EquipmentSurveyInput
) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: {
            ...buildBuildingModelRequestVariables(buildingModelUid),
            equipmentSurvey: equipmentData,
        },
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data) => {
        if (data.submitEquipmentSurvey.error)
            throw new Error(data.submitEquipmentSurvey.error);
        return data.submitEquipmentSurvey.success;
    });

const query = graphql(`
    mutation submitEquipmentSurvey(
        $buildingModelUid: Uuid!
        $equipmentSurvey: EquipmentSurveyInput!
    ) {
        submitEquipmentSurvey(
            buildingModelUid: $buildingModelUid
            equipmentSurvey: $equipmentSurvey
        ) {
            error
            success
        }
    }
`);

export default queryFn;
